import axios from 'axios'

class ContactRepository {
  send (data) {
    return axios.post(`${BASE_URL}/contact`, data)
    .then(response => {
      return response.data
    })
  }
}

export default new ContactRepository()




// WEBPACK FOOTER //
// ./src/data/contact.repository.js